import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { Container, Dialog, Grid, Stack, styled } from "@mui/material";
import { DialogContent, TextField, Typography } from "@mui/material";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";
import Loader from "../components/Loader";
import { IncentivesFeature } from "../features/IncentivesFeature";

const ValueBox = styled(Box)({
  background: "#E2FFE3",
  width: "100%",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "15px",
});

function PaySalary({ open, onClose, item, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    paid: 0,
  });

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const updateSalary = async () => {
    if (!state.paid) {
      Toast("info", "Kindly Enter Amount");
      return;
    }
    setLoading(true);
    let { data } = await Repo.salary({
      request: {
        method: "updateSalary",
        data: {
          _id: item._id,
          paid: state.paid,
        },
      },
    });
    setLoading(false);
    toggle();
    if (data.response.status.statusCode == 200) {
      Toast("success", "Salary is Paid");
    } else {
      Toast("error", "Salary is not Paid");
    }
    onSuccess();
  };
  return (
    <Dialog open={open} onClose={toggle} fullWidth>
      <DialogContent>
        <Container>
          <Typography
            variant="h6"
            sx={{ textAlign: "center", color: "#4EAF50" }}
          >
            Pay Employee Salary!
          </Typography>

          <TextField
            fullWidth
            size="small"
            label="Enter amount paid"
            sx={{ borderRadius: "6px", fontSize: "12px", my: 3 }}
            variant="outlined"
            value={state.paid}
            type="number"
            name="paid"
            onChange={handleInput}
          />

          <Grid container spacing={1} justifyContent="space-between">
            <Grid item md={4} xs={6}>
              <Typography
                varinat="h6"
                sx={{ textAlign: "center", color: "#4EAF50" }}
              >
                Monthly Salary!
              </Typography>

              <ValueBox>
                <Typography variant="body1">{item?.currentSalary}</Typography>
                <Typography variant="body1" sx={{ ml: 1 }}>
                  Rs
                </Typography>
              </ValueBox>
            </Grid>
            {IncentivesFeature() && (
              <Grid item md={4} xs={6}>
                <Typography
                  varinat="h6"
                  sx={{ textAlign: "center", color: "#4EAF50" }}
                >
                  Incentive!
                </Typography>

                <ValueBox>
                  <Typography variant="body1">
                    {item?.incentive || 0}
                  </Typography>
                  <Typography variant="body1" sx={{ ml: 1 }}>
                    Rs
                  </Typography>
                </ValueBox>
              </Grid>
            )}
            <Grid item md={4} xs={6}>
              <Typography
                varinat="h6"
                sx={{ textAlign: "center", color: "#4EAF50" }}
              >
                Remaining Salary!
              </Typography>

              <ValueBox>
                <Typography variant="body1">
                  {IncentivesFeature() && item.incentive
                    ? parseFloat(item?.remaining) +
                      parseFloat(item?.incentive) -
                      state.paid
                    : parseFloat(item?.remaining) - state.paid}
                </Typography>
                <Typography variant="body1" sx={{ ml: 1 }}>
                  Rs
                </Typography>
              </ValueBox>
            </Grid>
          </Grid>
          {loading && <Loader loading={loading} />}
          {!loading && (
            <Stack
              marginTop="50px"
              direction="row"
              justifyContent="space-evenly"
              spacing={10}
            >
              <Button
                fullWidth
                variant="contained"
                sx={{ background: "rgb(138, 138, 138) !important" }}
                onClick={toggle}
              >
                Cancel
              </Button>
              <Button fullWidth variant="contained" onClick={updateSalary}>
                Add
              </Button>
            </Stack>
          )}
        </Container>
      </DialogContent>
    </Dialog>
  );
}

export default PaySalary;
